const data = {
  counterText: 'สล็อตมีจำนวนจำกัด',
  loading: 'กำลังโหลด',
  next: 'ถัดไป',
  previous: 'ก่อน',
  smCounterText: '',
};

export default data;
